import {
  ElementCategoryID,
  IElementCategory,
} from '../../../models/element-categories.model';
import {
  gypsumProductMap,
  GypsumPropertyName,
  BoardType,
} from './gypsum.model';
import {
  DEFAULT_AREAL_DENSITY_PROPERTIES,
  DEFAULT_QUANTITY_PROPERTIES,
} from '../../../models/element-quantities.model';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
  IConditionalNode,
} from '../../../helpers/conditional-nodes.helpers';
import { reusedContentProperty } from '../reused-content-property.model';
import { ProductID } from '../../../models/product.model';
import { ElementPropertyType } from '../../../models/element-property.model';
import { commonElementCategoryProperties } from '../common-element-category-properties.model';

export const gypsumProductIds: IConditionalNode<ProductID> = {
  property: GypsumPropertyName.BoardType,
  map: gypsumProductMap,
};

export const gypsum: IElementCategory = {
  id: ElementCategoryID.Gypsum,
  name: 'Gypsum',
  color: '#AC91CE',
  defaultSelectedQuantity: 'mass',
  properties: [
    {
      name: GypsumPropertyName.BoardType,
      type: ElementPropertyType.Select,
      count: BoardType.Standard,
      options: Object.values(BoardType),
    },
    reusedContentProperty,
    ...commonElementCategoryProperties,
  ],
  getQuantityProperties: () => ({
    ...DEFAULT_QUANTITY_PROPERTIES,
    ...DEFAULT_AREAL_DENSITY_PROPERTIES,
  }),
  // `throwIfNotFound: false` + `undefined` passthrough: tolerate transient
  // Select counts outside the conditional map; `undefined` makes the caller
  // skip enrichment and keep existing children (see metal.ts comment).
  getChildElements: (element) =>
    getValueFromConditionalNodes(element, [gypsumProductIds], false),
  getElementPropertySelectionByProductId: (productId: ProductID) =>
    getElementPropertySelectionByValue(productId, gypsumProductIds),
};
